<template>
  <div>
    <div class="form-group" v-if="slideActive.type === 'image'">
      <label class="label-option">
        <span class="mr-1">Heading</span>
        <TextAlignEdit />
      </label>
      <div class="mb-2 input-group input-option" :key="key">
        <InputText
          :val="slideActive.title"
          @interface="_setPayloadUpdate"
          place-holder="Slide heading…"
          spellcheck="false"
          :id-name="'title-slide-edit'"
          :index="''"
          :limit="300"
          type="input-image-title"
          :inputId="`slide-title-${slideActive.id}`"
        />
      </div>
    </div>
    <div class="form-group">
      <label class="label-option">
        <span class="mr-1">Image uploader</span>
        <span class="title-table-presentation-tooltip result-layout-tooltip">
          <b-button v-tooltip="'Max file size: 15MB'" class="tooltip-btn" />
          <i class="fas fa-question-circle" />
        </span>
      </label>

      <div class="button-add-image" v-if="!slideActive.image">
        <aha-button class="" @click="openModalUploadImage">
          <font-awesome-icon icon="image" />
          <span class="pl-1">Add image</span>
        </aha-button>
      </div>
      <div class="slide-image-config horizontal layout" v-if="slideActive.image">
        <div class="image-box">
          <img :src="slideActive.image.thumbnail" alt>
        </div>
        <div>
          <div class="horizontal layout center">
            <a>
              <i class="pr-2 far fa-image" />
              <span @click="openModalUploadImage">Change image</span>
            </a>
          </div>
          <div class="horizontal layout center">
            <a style="margin-top:0;">
              <i class="pr-2 fas fa-trash-alt" />
              <span @click="deleteImage()">Remove</span>
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group" v-if="slideActive.type == 'image'">
      <label class="label-option">Layout</label>
      <div class="select-group">
        <label for="as-center-image">
          <input
            type="radio"
            name="layoutImage"
            value="default"
            id="as-center-image"
            v-model="slideActive.imageType"
            @change="updateImageType"
          > Centred
        </label>
      </div>
      <div class="select-group">
        <label for="image-as-bg">
          <input
            type="radio"
            name="layoutImage"
            value="background"
            id="image-as-bg"
            v-model="slideActive.imageType"
            @change="updateImageType"
          > Full screen
        </label>
      </div>
    </div>

    <UploadImageV2
      :type="'slideImage'"
      v-if="isUploadImageModalShowing"
      @hideModal="hideModalUploadImage"
      @callback="handleImageUpload"
      :updateGifInBackground="handleUpdateGifInBackground"
      @selectExistImage="selectExistImage"
    />

    <CropImageV2
      v-if="isCropImageModalShowing"
      :image-url="slideContentImageUrl"
      @on-cancel="handleCancelCrop"
      @hideModal="isCropImageModalShowing = false"
      :updateInBackground="handleUpdateInBackground"
    />

    <div class="form-group" :key="key">
      <label class="label-option">
        <span v-if="slideActive.type != 'document'">Caption</span>
        <span v-if="slideActive.type == 'document'">
          Slide name (optional)
        </span>
        <span
          v-if="slideActive.type == 'document'"
          class="title-table-presentation-tooltip result-layout-tooltip"
        >
          <b-button
            v-tooltip="slideNameTooltip"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
      </label>
      <InputText
        v-if="slideActive.type === 'image'"
        :val="slideActive.subheading"
        @interface="_setPayloadUpdate"
        place-holder="Image caption…"
        spellcheck="false"
        :id-name="'image-caption-slide-edit'"
        :index="''"
        :limit="80"
        type="input-option"
      />
      <InputText
        v-if="slideActive.type === 'document'"
        :val="slideActive.title"
        @interface="_setPayloadUpdate"
        place-holder="Slide name.."
        spellcheck="false"
        :id-name="'document-title-slide-edit'"
        :index="''"
        :limit="80"
        :inputId="`slide-title-${slideActive.id}`"
      />
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

import UploadImageV2 from '@/components/presentations/UploadImage.v2.vue'
import Config from '@/config'
import Socket from '@/socket'
import Util from '@/util'
import InputText from '@/components/presentations/InputText'
import EventBus from '@/eventBus'
import CropImageV2 from '@/components/presentations/CropImage.v2.vue'
import TextAlignEdit from '@/components/presentations/TextAlignEdit'
import UndoRedoMixin from '@/mixins/undo-redo/UndoRedoMixin'
import {
  setObjectToIndexedDB,
  removeObjectFromIndexedDB,
  Stores,
} from '@/utils/indexedDB/indexed.db'

export default {
  components: {
    InputText,
    CropImageV2,
    UploadImageV2,
    TextAlignEdit,
  },
  mixins: [UndoRedoMixin],
  data() {
    return {
      key: null,
      showTextAlign: true,
      slideContentImageUrl: null,
      isCropImageModalShowing: false,
      isUploadImageModalShowing: false,
    }
  },
  computed: {
    ...mapState({
      slideActive: (state) => state.slideActive,
    }),
    slideNameTooltip() {
      return "This is to help you to identify this slide among other slides in the presentation. It won't be visible to your audience."
    },
  },
  mounted() {
    this.registerHistory()
    EventBus.$on('open-add-image-modal', () => {
      this.openModalUploadImage()
    })
  },
  destroyed() {
    EventBus.$off('open-add-image-modal')
  },
  methods: {
    ...mapActions(['updateSlideActiveAction', 'setSyncPresentationAction']),
    openModalUploadImage() {
      this.isUploadImageModalShowing = true
    },
    deleteImage() {
      this.updateSlideActiveAction({ image: null })
      EventBus.$emit('eventHandleSetValueTransition')
      this.updateSlide({
        image: null,
      })
      removeObjectFromIndexedDB(this.slideActive.id, Stores.questionImageStore)
    },
    hideModalUploadImage() {
      this.isUploadImageModalShowing = false
    },
    updateImageType() {
      this.updateSlide({
        imageType: this.slideActive.imageType,
      })
    },
    backupUpdateSlide(newData) {
      const oldData = {
        ...newData,
        value: newData.idName === 'image-caption-slide-edit' ? this.slideActive.subheading : this.slideActive.title,
      }

      if (oldData.value !== newData.value) {
        this.addHistoryUpdateTitleSlide(newData, oldData)
      }
    },
    addHistoryUpdateTitleSlide(newValue, oldValue) {
      this.addActionToHistory({
        type: 'UpdateTitleImage',
        data: JSON.parse(JSON.stringify(oldValue)),
        newData: JSON.parse(JSON.stringify(newValue)),
        slideActiveId: this.slideActive.id,
      })
    },
    async restoreUpdateTitleImage(data) {
      if (data.value === null) {
        data.value = ''
      }
      await this._setPayloadUpdate(data, false)
      this.key = (new Date()).getTime()
    },
    _setPayloadUpdate(data, isBackup = true) {
      if (isBackup) {
        this.backupUpdateSlide(data)
      }
      data.value = this._setEmptyValue(data) // This to display empty content on canvas
      if (data.idName === 'image-caption-slide-edit') {
        this.updateSlide({
          subheading: data.value,
        })
      } else if (data.idName === 'title-slide-edit' || data.idName === 'document-title-slide-edit') {
        this.updateSlide({
          title: data.value,
          titleHTML: data.value,
        })
      }
    },
    _setEmptyValue(data) {
      if (!data.value || (data.value && data.value.replace(/\s/g, '') === '')) {
        data.value = ' '
      }
      return data.value
    },
    async updateSlide(payload) {
      this.setSyncPresentationAction(1)
      this.updateSlideActiveAction(payload)

      payload = {
        ...payload,
        presentationId: this.$store.state.presentation.id,
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        socketId: Socket.getSocketId(),
        presenting: this.$store.getters.isPresenting,
      }

      try {
        await this.$http.put(Config.api.updateSlide + this.slideActive.id, payload)

        if (payload.title) {
          Util.gaTrackEvent('Slide', 'Edit slide title', 'Update slide image title', null, {
            slideId: this.slideActive.id,
          })
        }

        if (payload.subheading) {
          Util.gaTrackEvent('Slide', 'Slide image caption', 'Update slide image caption', null, {
            slideId: this.slideActive.id,
          })
        }

        if (payload.image === null) {
          Util.gaTrackEvent('Slide', 'Remove slide image', 'Done remove slide image', null, {
            slideId: this.slideActive.id,
          })
        }

        if (payload.imageType) {
          EventBus.$emit('eventHandleSetValueTransition')
          Util.gaTrackEvent('Slide', 'Update slide image type', payload.imageType, null, {
            slideId: this.slideActive.id,
          })
        }

        this.setSyncPresentationAction(2)
      } catch {
        this.setSyncPresentationAction(3)
      }
    },
    async handleImageUpload(imageUrl) {
      const extension = imageUrl.split('?')[0].split('.').pop()

      if (extension !== 'gif') {
        this.cropperData = null
        this.isCropImageModalShowing = true
        this.isUploadImageModalShowing = false
        this.slideContentImageUrl = imageUrl
      }
    },

    updateImageLocally({
      blob, extension,
    }) {
      const url = URL.createObjectURL(blob)
      this.updateSlideActiveAction({
        image: { thumbnail: url, large: url, xLarge: url },
        showQuestionImage: true,
      })
      const payload = {
        blob,
        extension,
      }
      setObjectToIndexedDB(this.slideActive.id, Stores.questionImageStore, payload)
      EventBus.$emit('eventHandleSetValueTransition')
    },

    async handleResizeImage(imageUrl) {
      const croppedImage = imageUrl.split('?')[0]
      const extension = croppedImage.split('.').pop()
      return this.$http.post(Config.api.uploadSlideImage, {
        extension,
        slideId: this.slideActive.id,
        image: imageUrl,
        socketId: Socket.getSocketId(),
        accessCode: this.$store.state.presentation.uniqueAccessCode,
      })
    },

    async handleUploadLinkImage(imageUrl) {
      return this.$http.post(Config.api.uploadLink, {
        image: imageUrl,
      })
    },

    async handleUpdateGifInBackground(data) {
      const { imageUrl } = data
      const blob = await fetch(imageUrl).then((r) => r.blob())
      this.updateImageLocally({
        blob,
        cropperData: null,
        extension: 'gif',
        selectedSlides: data.selectedSlides,
      })
      this.isUploadImageModalShowing = false
      const uploadLinkResponse = await this.handleUploadLinkImage(imageUrl)
      const s3ImageUrl = uploadLinkResponse.body.file
      await this.handleResizeImage(s3ImageUrl)
    },

    async selectExistImage(attachment) {
      this.updateSlideActiveAction({
        image: attachment,
      })
      const payload = {
        image: attachment.name,
        presentationId: this.$store.state.presentation.id,
        accessCode: this.$store.state.presentation.uniqueAccessCode,
        socketId: Socket.getSocketId(),
        presenting: this.$store.getters.isPresenting,
      }
      await this.$http.put(Config.api.updateSlide + this.slideActive.id, payload)
      this.isUploadImageModalShowing = false
    },

    async handleUploadCroppedImage(formData) {
      return this.$http.post(Config.api.uploadImage, formData)
    },

    createUploadFormData(data) {
      const formData = new FormData()
      formData.append('file', data.file)
      formData.append('socketId', Socket.getSocketId())
      formData.append('accessCode', data.accessCode)

      return formData
    },

    async handleUpdateInBackground(data) {
      this.updateImageLocally({
        blob: data.blob,
        extension: 'jpg',
        selectedSlides: data.selectedSlides,
      })
      this.isCropImageModalShowing = false

      const uploadFormData = this.createUploadFormData(data)

      const uploadRes = await this.handleUploadCroppedImage(uploadFormData)

      // because the croppedImage is signed
      // therefore, we need to remove all the queries in the url
      const imageUrl = uploadRes.body.file.location
      await this.handleResizeImage(imageUrl)
    },

    async handleCropImageFinished(data) {
      const { slideActive } = this.$store.state
      const { id: activeSlideId } = slideActive

      // because the croppedImage is signed
      // therefore, we need to remove all the queries in the url
      const croppedImage = data.crop.split('?')[0]
      const extension = croppedImage.split('.').pop()

      const res = await this.$http.post(Config.api.uploadSlideImage, {
        extension,
        image: data.crop,
        slideId: activeSlideId,
        socketId: Socket.getSocketId(),
        accessCode: this.$store.state.presentation.uniqueAccessCode,
      })

      const payload = {
        showQuestionImage: !slideActive.multipleCountAnswer,
      }
      await this.$http.put(Config.api.updateSlide + activeSlideId, payload)
      this.updateSlideActiveAction({
        image: res.body,
        showQuestionImage: payload.showQuestionImage,
      })

      this.isCropImageModalShowing = false

      EventBus.$emit('eventHandleSetValueTransition')
    },

    handleCancelCrop() {
      this.isCropImageModalShowing = false
      this.isUploadImageModalShowing = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variable.scss";
.select-group {
  label {
    cursor: pointer;
  }

  input {
    cursor: pointer;
  }
}

.slide-image-config {
  background-color: #f2f2f2;
  padding: 8px;

  .image-box {
    margin: auto 10px auto 0;
    img {
      max-width: 150px;
      max-height: 90px;
    }
  }

  a {
    margin: 16px 0;
  }
}
</style>
